import Vue from 'vue'
import VueCarousel from 'vue-carousel'
import VCalendar from 'v-calendar'
import VueYouTubeEmbed from 'vue-youtube-embed'
import vueVimeoPlayer from 'vue-vimeo-player'
import Maska from 'maska'
import router from '@router'
import store from '@state/store'
import { BootstrapVue, BootstrapVueIcons, ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import LogRocket from 'logrocket'
import logRocketConfig from '@src/config/logRocketConfig'
import pwaNotificationConfig from '@src/config/pwaNotificationConfig'
import { init as initVeeValidate } from '@src/config/veeValidateConfig'
import '@src/design/custom_variables.scss'
import _ from 'lodash'
import axios from 'axios'
import App from './app.vue'
// Globally register all `_base`-prefixed components
import '@components/base/_globals'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueCarousel)
Vue.use(VueYouTubeEmbed)
Vue.use(vueVimeoPlayer)
Vue.use(Maska)
Vue.use(VCalendar)
Vue.set(Vue.prototype, '_', _)
initVeeValidate(Vue)
if (!process.env.VUE_E2E_TEST) {
  try {
    pwaNotificationConfig()
  } catch (err) {}
}
// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.prototype.log = console.log
// If running inside Cypress...
if (process.env.VUE_E2E_TEST) {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress?.cy?.onUncaughtException
}
Vue.prototype.$screen = new Vue({
  data: {
    screen: {
      width: window.innerWidth,
      height: window.innerHeight,
    },
  },
}).screen

window.addEventListener('resize', () => {
  Vue.prototype.$screen.width = window.innerWidth
  Vue.prototype.$screen.height = window.innerHeight
})

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    async function logOut() {
      store.commit('auth/SET_ADMIN_AUTH_ERROR', 'Your session has expired. Please log in again')
      store.commit('auth/SET_CURRENT_TOKEN', null)
      await store.dispatch('auth/logOut')
    }
    const status = error.response ? error.response.status : null
    if (status === 498) {
      if (error.config?.url === '/user/extend-session') {
        await logOut()
        return Promise.reject(error)
      }

      const originalRequest = error.config
      await axios
        .get('/user/extend-session')
        .then((response) => {
          const token = response.data
          store.commit('auth/SET_CURRENT_TOKEN', token)

          return axios(originalRequest)
            .then((response) => {
              return response.data
            })
            .catch(async (error) => {
              await logOut()
              return Promise.reject(error)
            })
        })
        .catch(async (error) => {
          await logOut()
          return Promise.reject(error)
        })
    }

    return Promise.reject(error)
  }
)

const app = new Vue({
  data() {
    return {
      debugOptions: {},
    }
  },
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_E2E_TEST) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}

if (app.$store.getters['user/shouldInitLogRocket']) {
  LogRocket.init(process.env.LOG_ROCKET_APP_ID, logRocketConfig())
}

window.addEventListener('beforeinstallprompt', (evt) => {
  app.$store.commit('pwa/SET_BEFORE_PWA_INSTALL_PROMPT', evt)
})

window.addEventListener('appinstalled', () => {
  app.$store.commit('pwa/SET_BEFORE_PWA_INSTALL_PROMPT', null)
})
